import ActivityType from "@mapmycustomers/shared/types/entity/activities/ActivityType";

// An empty saved list means "all types", so a type added to the org later is selected too.
export const getSavedActivityTypeIds = (
  selectedActivityTypes: ActivityType[],
  activeActivityTypes: ActivityType[]
): ActivityType["id"][] =>
  selectedActivityTypes.length === activeActivityTypes.length
    ? []
    : selectedActivityTypes.map(({ id }) => id);

export const resolveSavedActivityTypes = (
  activeActivityTypes: ActivityType[],
  savedActivityTypeIds: ActivityType["id"][] | undefined
): ActivityType[] => {
  const savedIds = new Set(savedActivityTypeIds);
  const selected = activeActivityTypes.filter(({ id }) => savedIds.has(id));
  return selected.length ? selected : activeActivityTypes;
};
